import {api} from "../../services";
import Swal from "sweetalert2";

const users = {
  state: {
    pagination: [],
    data: [],
    user: {
      channels_id: []
    }
  },
  getters: {
    getUserObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getUsersArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          if (key === 'channels_id') {
            let goes = false
            if (item.id  !== 1) {
              value.forEach(channel_id => {
                if (item.channels_id.includes(channel_id)) {
                  goes = true
                }
              })
            }
            return goes
          } else {
            return item[`${key}`] === value;
          }
        });
      }
      return [];
    },
    // getUsersArray: (state) => (key, value) => {
    //   if (state.data !== undefined) {
    //     return state.data.filter(item => {
    //       return item[`${key}`] === value;
    //     });
    //   }
    //   return [];
    // },
  },
  mutations: {
    SET_USERS(state, payload) {
      state.pagination = payload
    },
    SET_USERS_DATA(state, payload) {
      payload.forEach(p => {
        const exist = state.data.find(e => {
          return e.id === p.id;
        });
        if (!exist) {
          state.data.push(p);
        }
      });
    },
    SET_USER(state, payload) {
      state.user = payload
    },
    REMOVE_USER_DATA(state, payload) {
      const existIndex = state.data.findIndex(e => {
        return e.id === payload.id;
      });
      if (existIndex > -1) {
        state.data.splice(existIndex, 1);
      }
    },
  },
  actions: {
    getUsers(context) {
      api.get('/users').then(response => {
        context.commit("SET_USERS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    searchUsers(context, payload) {
      api.get('/users', {
        params: payload
      }).then(response => {
        context.commit("SET_USERS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    getUsersData(context, payload) {
      let ids = [];
      payload.forEach(p => {
        const item = context.state.data.find(i => {
          return p === i.id
        });
        if (item === undefined) {
          ids.push(p)
        }
      });
      if (ids.length > 0) {
        api.post(`/users`, {ids}).then(response => {
          context.commit("SET_USERS_DATA", response.data);
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          } else {
            Swal.fire(
              `${ context.rootGetters.getTranslations('expression_406')}`,
              `${error.response.data.message}`,
              'warning'
            )
          }
        });
      }
    },
    getUser(context, payload) {
      api.get(`/users/${payload.id}`).then(response => {
        context.commit("SET_USER", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    updateUser(context, payload) {
      api.put(`/users/${payload.id}`, payload).then(response => {
        context.commit("SET_USER", response.data);

        // Seta preferencia do usuário no LS
        window.localStorage.setItem("temp_lang", payload.language_key)

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_933'),
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    updateUserOnline(context, payload) {
      api.put(`/users/${payload.id}`, payload).then(response => {
        context.commit("SET_USER", response.data);

        // Seta preferencia do usuário no LS
        window.localStorage.setItem("temp_lang", payload.language_key)
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    getUsersAll(context) {
      api.get(`/users/all`).then(response => {
        context.commit("SET_USERS_DATA", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    deleteUser(context, payload) {
      api.delete(`/users/${payload.id}`).then(() => {
        context.commit("REMOVE_USER_DATA", payload);
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_906') }`,
          `${ context.rootGetters.getTranslations('expression_967') }`,
          'success'
        ).then(() => {
          this.dispatch('getUsers')
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    restoreUser(context, payload) {
      api.put(`/users/${payload.id}/restore`).then((response) => {
        context.commit("SET_USERS_DATA", [response.data]);
        window.localStorage.setItem("user_id", response.data.id)
        Swal.fire(
          `${ context.rootGetters.getTranslations('expression_406')}`,
          `${ context.rootGetters.getTranslations('expression_968') }`,
          'success'
        ).then(() => {
          setTimeout(() => {
            window.router.push({name: "User"});
          }, 500);
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${ context.rootGetters.getTranslations('expression_406')}`,
            `${error.response.data.message}`,
            'warning'
          )
        }
      });
    },
    addUser(context, payload) {
      api.post(`/users`, payload).then((response) => {
        context.commit("SET_USERS_DATA", [response.data]);
        window.localStorage.setItem("user_id", response.data.id);
        this.dispatch("getUser", response.data);
        // Realiza o redirecionamento somente se skipRedirect não estiver definido no payload
        if (!payload.skipRedirect) {
          setTimeout(() => {
            window.router.push({ name: "User" });
          }, 500);
        }
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          if (error.response.data.user) {
            Swal.fire({
              title: `${ context.rootGetters.getTranslations('expression_969') }`,
              text: `${error.response.data.message}`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não'
            }).then((result) => {
              if (result.isConfirmed) {
                if (error.response.data.user.deleted_at === null) {
                  window.localStorage.setItem("user_id", error.response.data.user.id);
                  this.dispatch("getUser", error.response.data.user);
                  if (!payload.skipRedirect) {
                    setTimeout(() => {
                      window.router.push({ name: "User" });
                    }, 500);
                  }
                } else {
                  this.dispatch("restoreUser", error.response.data.user);
                }
              }
            });
          } else {
            Swal.fire(
              `${ context.rootGetters.getTranslations('expression_406') }`,
              `${error.response.data.message}`,
              'warning'
            );
          }
        }
      });
    }
    
    // addUser(context, payload) {
    //   api.post(`/users`, payload).then((response) => {
    //     context.commit("SET_USERS_DATA", [response.data]);
    //     window.localStorage.setItem("user_id", response.data.id)
    //     this.dispatch("getUser", response.data)
    //     setTimeout(() => {
    //       window.router.push({name: "User"});
    //     }, 500);
    //   }).catch(error => {
    //     if (error.response.status === 401) {
    //       this.dispatch('logoutUser');
    //     } else {
    //       if (error.response.data.user) {
    //         Swal.fire({
    //           title: `${ context.rootGetters.getTranslations('expression_969') }`,
    //           text: `${error.response.data.message}`,
    //           icon: 'warning',
    //           showCancelButton: true,
    //           confirmButtonColor: '#d33',
    //           confirmButtonText: 'Sim',
    //           cancelButtonText: 'Não'
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             if (error.response.data.user.deleted_at === null) {
    //               window.localStorage.setItem("user_id", error.response.data.user.id)
    //               this.dispatch("getUser", error.response.data.user)
    //               setTimeout(() => {
    //                 window.router.push({name: "User"});
    //               }, 500);
    //             } else {
    //               this.dispatch("restoreUser", error.response.data.user)
    //             }
    //           }
    //         })
    //       } else {
    //         Swal.fire(
    //           `${ context.rootGetters.getTranslations('expression_406')}`,
    //           `${error.response.data.message}`,
    //           'warning'
    //         )
    //       }
    //     }
    //   });
    // }
  },
}
export default users;
